export default __webpack_public_path__ + "static/media/instagram30.00ab54c2.png";